import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../redux/library/selector";
import { accountCategories } from "../../../../../../redux/account-categories/action";
import { selectAccountCategoriesListItems } from "../../../../../../redux/account-categories/selector";

const ManagementAccountCategories = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const libraryData = useSelector(selectListItems)
    const accountCategoriesItemsData = useSelector(selectAccountCategoriesListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'CategoryName', headerName: 'Category Name',searchField: 'CategoryName', sortable: true, filter: true, filterType: 'text' },
            {
                field: 'AccountHeadId',
                headerName: 'Account Head',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.AccountHead }
            },
            { field: 'IsSubCategory', headerName: 'Sub Category', cellRenderer: 'yesNoRenderer' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }

    const fetchAccountCategoriesList = () => {
        dispatch(accountCategories.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories/list`,
            entity: 'accountCategories',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchAccountCategoriesList()
    }, [pageData, pageSize])

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchAccountCategoriesList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Account Category</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "CategoryName",
            FieldText: "CategoryName",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } 

        dispatch(accountCategories.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories/list`,
            entity: 'accountCategories',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }))
    }

    // const additionButtons: any = [
    //     {
    //         name: 'Add Account Category',
    //         callback: () => handleAdd(),
    //     }
    // ];

   

    return (
        <>
            {accountCategoriesItemsData?.isLoading ?
                <PageLoader /> :
                <Table columnData={columnDefs} rowData={accountCategoriesItemsData?.result?.items} setPageData={setPageData}
                 enableFilter={true} onSearch={handleSearch}    setPageSize={setPageSize} paginationData={accountCategoriesItemsData?.result?.pagination}
                    additionButtons={additionButtons} onEdit={handleEdit}
                    headingName="Ledger Categories" />
            }
        </>
    );
};

export default ManagementAccountCategories;



